import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'

import { SingleText, SingleMultilineText, SingleSelect } from '../../Res/BaseInput';
import { CancelSubmitButton, Space } from '../../Res/BaseButton';
import { ContentBox } from '../../Content/ContentBox';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { getval2Token } from '../../../Login/Auth';
import { RespCustomerPositionInfo, WageType_Arr, JobDemand_Arr, ReqCustomerPositionDetail, WageType0, RespCustomerPosition, RespCustomerPositionDetail } from '../../../../item/ItemCustomerPosition';
import { api_addCustomerPosition, api_getCustomerPositionDetail } from '../../../../api/apiCustomerPosition';
import { getItemsInfo } from '../../../../item/ItemTools';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import moment from 'moment';


export function PositionDemandEdit({ id, setIsLoading, isEdit = false, isML=false }) {
  const [tokenId, setTokenId] = useState("")
  const [customerContractId, setCustomerContractId] = useState("")
  const [customerPositionId, setCustomerPositionId] = useState("")

  const [info, setInfo] = useState({})
  const [companyName, setCompanyName] = useState("")
  const [signAt, setSignAt] = useState("")
  const [isPublic, setIsPublic] = useState("")
  const [job, setJob] = useState("")
  const [shift, setShift] = useState("")
  const [workPlace, setWorkPlace] = useState("")
  const [workAddress, setWorkAddress] = useState("")
  const [jobRequirement, setJobRequirement] = useState("")
  const [jobDemand, setJobDemand] = useState("")
  const [wageType, setWageType] = useState(WageType0)
  const [wageInfo, setWageInfo] = useState("")


  const [laborInsuranceType, setLaborInsuranceType] = useState("0")
  const [laborInsuranceLevel, setLaborInsuranceLevel] = useState("0")
  const [healthInsuranceLevel, setHealthInsuranceLevel] = useState("0")


  useEffect(() => {
    setIsLoading(true)
    if (id !== undefined && id !== tokenId) {
      var obj = getval2Token("positionDemand", id)
      // var cId = getval2Token("customerContractId", id)
      setCustomerContractId(obj.customerContractId)
      // var pId = getval2Token("customerPositionId", id)
      setCustomerPositionId(obj.customerPositionId)
      setTokenId(id)
    }
  }, [id])

  useEffect(() => {
    if (customerPositionId !== undefined && customerPositionId !== "") {
      setIsLoading(true)
      var mReqCustomerPositionDetail = new ReqCustomerPositionDetail({
        customerPositionId,
        customerContractId
      })
      getDetail(mReqCustomerPositionDetail)
    }
  }, [customerPositionId])

  useEffect(() => {
    //console.log(wageType)
    //console.log(WageType0)
    if (wageType === WageType0) {
      setWageInfo({})
    }
  }, [wageType])


  function getDetail(mReqCustomerPositionDetail) {
    console.log(mReqCustomerPositionDetail)
    api_getCustomerPositionDetail({
      mReqCustomerPositionDetail,
      success: (jsonData) => {
        console.log(jsonData)
        var mRespCustomerPositionDetail = new RespCustomerPositionDetail({})
        mRespCustomerPositionDetail.fromJson(jsonData.detail)
        console.log(mRespCustomerPositionDetail)

        setCompanyName(mRespCustomerPositionDetail.companyName)
        setSignAt(moment(mRespCustomerPositionDetail.signAt).format('YYYY-MM-DD'))
        setIsPublic(mRespCustomerPositionDetail.isPublic===1?"是":"否")
        setInfo(mRespCustomerPositionDetail.info)
        setJob(mRespCustomerPositionDetail.info.job)
        setShift(mRespCustomerPositionDetail.info.shift)
        setWorkPlace(mRespCustomerPositionDetail.info.workPlace)
        setWorkAddress(mRespCustomerPositionDetail.info.workAddress)
        setJobRequirement(mRespCustomerPositionDetail.info.jobRequirement)
        setJobDemand(mRespCustomerPositionDetail.info.jobDemand)
        setWageType(mRespCustomerPositionDetail.info.wageType)
        setWageInfo(mRespCustomerPositionDetail.info.wageInfo)
        setLaborInsuranceType(mRespCustomerPositionDetail.info.laborInsuranceType)
        setLaborInsuranceLevel(mRespCustomerPositionDetail.info.laborInsuranceLevel)
        setHealthInsuranceLevel(mRespCustomerPositionDetail.info.healthInsuranceLevel)

        setIsLoading(false)
      },
      failure: (err) => {
        console.log(err)
        setIsLoading(false)
      }
    })
  }

  function setDemand() {

    var mRespCustomerPositionInfo = new RespCustomerPositionInfo({})
    mRespCustomerPositionInfo.fromJson(info)
    mRespCustomerPositionInfo.jobDemand = jobDemand

    var mRespCustomerPosition = new RespCustomerPositionDetail({
        customerContractId,
        customerPositionId,
        info: JSON.stringify(mRespCustomerPositionInfo),
    })

        // console.log(mRespCustomerPositionInfo)
        // console.log(mRespCustomerPosition)

    // return
    api_addCustomerPosition({
        mRespCustomerPosition,
        success: (jsonData) => {
            Swal.fire({
                type: 'success',
                title: '提醒',
                text: '更新成功',
            }).then(function () {
                window.history.back(-1);
            })
        },
        failure: (err) => {
            Swal.fire({
                type: 'error',
                title: '提醒',
                text: err,
            })
        }
    })
}

  function toCancel() {
    window.history.back();
  }

  var title = "職缺資訊"
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          <div className="col-md-6">
            <p>招募資訊</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"合約日期"} val={signAt} />
          <SingleText title={"廠商名稱"} val={companyName} />
          <SingleText title={"共補職缺"} val={isPublic} />
        </div>
      </div>
      <Space />
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"職稱"} val={job} />
          <SingleText title={"班別名稱"} val={shift} />
          <SingleText title={"工作地點"} val={workPlace} />
          <SingleText title={"工作地址"} val={workAddress} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleMultilineText title={"招募條件"} val={jobRequirement} size={12} />
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleText title={"服務費計算方式"} val={getItemsInfo({ items: WageType_Arr, val: wageType })} />
          {isEdit ?
            <SingleSelect title={"職缺需求量"}
              val={jobDemand}
              attr={JobDemand_Arr}
              action={setJobDemand}
              hasBlank={true}
            />
            :
            <SingleText title={"職缺需求量"} val={getItemsInfo({ items: JobDemand_Arr, val: jobDemand })} />
          }
        </div>
      </div>
    </>

  var footer =
    <div className="row">
      {
        !isEdit ? <></> :
          <div className="col-sm-3 col-sm-offset-9">
            <CancelSubmitButton cancelAction={toCancel} submitName={"儲存"} submitAction={setDemand} isRight={true} />
          </div>
      }
    </div>

  return (
    <>
      <ContentBox title={title}  content={content} footer={footer}  hasDrawer={false} />
      <ManagementPrompt />
      <SystemPromptInput />
    </>
  )
}